// @flow
import * as types from "../ACTIONS/actionTypes";
import initialState from "./initialState";

export default function sampleTypeReducer(state = initialState.sampleTypes, action) {

    switch (action.type) {
        
        // GOT_SAMPLE_TYPES_LIST - moved to commonReducer

        case types.ADD_NEW_SAMPLE_TYPE: {
            const updatedSampleType = [...state.items, action.sampleType];
            sortSampleTypes(updatedSampleType);
            return {
                initialized: true,
                items: updatedSampleType
            };
        }
        case types.REMOVE_SAMPLE_TYPE: {
            const sampleTypeId = action.sampleTypeId;
            const updatedSampleTypes = state.items.filter(p => p.id !== sampleTypeId);
            return {
                initialized: true,
                items: updatedSampleTypes
            };
        }
        case types.UPDATE_SAMPLE_TYPE: {
            const sampleType = action.sampleType;
            const updatedSampleTypes = state.items.filter(p => p.id !== sampleType.id);
            updatedSampleTypes.push(action.sampleType); // re-add.
            sortSampleTypes(updatedSampleTypes);  // in place
            return {
                initialized: true,
                items: updatedSampleTypes
            };
        }
        default:
            return state;
    }
}

function sortSampleTypes(sampleTypes) {
    if(sampleTypes) {
        sampleTypes.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
    }
}
    